/**
 * App router configuration
 */
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RootLayout } from './layouts/RootLayout';
import { StatsPage } from '@/pages/StatsPage';
import { EventsPage } from '@/pages/EventsPage';
import { BrandsPage } from '@/pages/BrandsPage';
import { BrandCardPage } from '@/pages/BrandCardPage';
import { LinksPage } from '@/pages/LinksPage';
import { ComparePage } from '@/pages/ComparePage';
import { SettingsPage } from '@/pages/SettingsPage';
import { ProgramsPage } from '@/pages/ProgramsPage';
import { UnmappedInboxPage } from '@/pages/UnmappedInboxPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/brands" replace />,
      },
      {
        path: 'brands',
        element: <BrandsPage />,
      },
      {
        path: 'brands/:idOrSlug',
        element: <BrandCardPage />,
      },
      {
        path: 'admin/programs',
        element: <ProgramsPage />,
      },
      {
        path: 'admin/unmapped',
        element: <UnmappedInboxPage />,
      },
      {
        path: 'events',
        element: <EventsPage />,
      },
      {
        path: 'stats',
        element: <StatsPage />,
      },
      {
        path: 'links',
        element: <LinksPage />,
      },
      {
        path: 'compare',
        element: <ComparePage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: '*',
        element: <Navigate to="/brands" replace />,
      },
    ],
  },
]);
